import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="px-3 py-1 bg-gray-200 hover:bg-gray-300 rounded text-sm font-medium"
    >
      {i18n.language === 'fr' ? 'EN' : 'FR'}
    </button>
  );
}
